import React from 'react'
import { useAPI } from '../../../../shared/services/api/API';
import { WASHUB_CONSTANTS } from '../../../../shared/Constants';
import { MaterialReactTable } from 'material-react-table';
import { Box, Button } from '@mui/material';

export const RetailInvoiceList = (Props: any) => {
    const { httpPost } = useAPI();
    const generateRetailOrderInvoice = (row: any) => {
      const payload = {
        clientId: row.customer.client.id,
        invoiceId: row.invoiceId,
      }
      httpPost(WASHUB_CONSTANTS.API_URLS.RETAILSSTOREORDER_INVOICE_GENERATE_PDF_POST, payload).then((response) => {
         if (response.status === 200) {
            console.log('invoice response ---> ' + response.data)
         } else {
            if(response.data.error){        
            console.error('Error Updating Business: ', response.data.message);
            }
         }
      });
    }
  return (
    <div style={{padding:"5px 15px"}}>
      <MaterialReactTable
          displayColumnDefOptions={{
            'mrt-row-actions': {
              muiTableHeadCellProps: {
                align: 'center',
              },
              size: 100,
            },
          }}
          columns={Props?.columns}
          data={Props?.tableData}
          editDisplayMode="cell" // ('modal', 'row', 'cell', and 'custom' are also available)
          enableEditing
          positionActionsColumn="last"
          enableRowActions
          enableFullScreenToggle={false}
          enableStickyHeader
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Button
                variant="contained"
                onClick={() => generateRetailOrderInvoice(row.original)}
              >
                Downoad Pdf
              </Button>
            </Box>
          )}
        />
      </div>
  )
}